<div class="card">
    <div class="card__header d-flex align-items-center" #iconContainer>
        <ng-content select="[deloitteaiProductCardIcon]"></ng-content>
        <img *ngIf="!hasCustomIcon" [src]="product.icon_url | safe:'resourceUrl'" (click)="handleClick($event)"
            class="pointer">
    </div>
    <div class="card__body">
        <div class="card__body--title">
            {{product.name}}
        </div>

        <deloitteai-ellipsed class="card__body--description">
            {{product.short_description}}
        </deloitteai-ellipsed>

        <aihub-tags [tags]="product.tags"></aihub-tags>

        <div class="card__body--details mt-3">
            <ng-content select="[sharedCardAction]"></ng-content>
            <ng-container *ngIf="!actionTrigger">
                <a *ngIf="!actionTrigger" (click)="handleClick($event)">See details</a>
                <i class="material-icons">
                    keyboard_arrow_right
                </i>
            </ng-container>
        </div>
    </div>
</div>